import { SocketModule } from './DI/SocketModule';
import type { ISocketClient, ISocketDispatcher } from './DI/interfaces';
import DITypes from './DI/types';

export { SocketModule, type ISocketClient, type ISocketDispatcher };
export const { SocketClient, SocketDispatcher } = DITypes;
